import {url} from '@rocket-ui/tools';
import axios from 'axios';

export const axiosInstance = axios.create({
	baseURL: '/api/tsp/v1',
	paramsSerializer: (params) => url.stringifyQueryString(params),
});

axiosInstance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response.status === 401 && error.response.data.code === 'REQUIRES_MANAGER_RIGHTS') {
			window.location.replace('/auth/logout');
		}
		return error;
	},
);
